// @flow

import React from 'react'
import Path from 'routes/path'

export type PropTypes = {
  data: {
    room: Object,
  },
  addedFavoriteListName?: ?string,
  showingFavoriteListTooltip: boolean,
  showingShare: boolean,
  favoritesCount: number,
  onClickFavorite: Function,
  onClickShare: Function,
}

export default (props: PropTypes) => (
  <ul className="space-side__buttons clearfix pc-hide__sm-show">
    <li className={props.favorited ? 'space-side__buttons-fav__on' : ''}>
      <div className="space-side__buttons-list">
        <a
          href=""
          className="space-side__buttons-favorite"
          onClick={props.onClickFavorite}
        >
          <i className="fa fa-heart" />
          {i18n.t('page.room.favorite')}
          <span className="space-side__buttons-fav__count">
            ({props.favoritesCount}
            {props.favoritesCount > 999 ? '+' : ''})
          </span>
        </a>
        {props.showingFavoriteListTooltip && (
          <div className="space-side__favorite">
            <div className="space-side__favorite-baloon">
              <p className="space-side__favorite-baloon-text">
                {props.addedFavoriteListName}
              </p>
            </div>
          </div>
        )}
      </div>
    </li>
    <li className="space-side__buttons-fav__select">
      <div className="space-side__buttons-list">
        <a
          href=""
          className={`space-side__buttons-select ${
            props.favorited ? 'space-side-fa_buttons-select-on' : ''
          }`}
          onClick={props.onClickFavorite}
        >
          <i className="fa fa-caret-down" />
        </a>
      </div>
    </li>
    <li className="space-side__buttons-share">
      <div className="space-side__buttons-list">
        <a
          href=""
          className="space-side__button-share"
          onClick={props.onClickShare}
        >
          <i className="fa fa-share-alt" />
          {i18n.t('page.room.share')}
        </a>
        {props.showingShare && (
          <div className="space-side__share-tooltip">
            <div className="baloon baloon-top user-detail-baloon space-side__share-baloon">
              <div className="baloon-inner">
                <ul className="space-side__social link__subcolor">
                  <li>
                    <a
                      href={Path.shareRoomTwitterUrl(props.data.room)}
                      target="_blank"
                    >
                      <i className="fa fa-twitter" />
                      twitter
                    </a>
                  </li>
                  <li>
                    <a
                      href={Path.shareRoomFacebookUrl(props.data.room)}
                      target="_blank"
                    >
                      <i className="fa fa-facebook-square" />
                      facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href={Path.shareRoomLineUrl(props.data.room)}
                      target="_blank"
                    >
                      <i className="icon-spm-line" />
                      LINE
                    </a>
                  </li>
                  <li>
                    <a
                      href={Path.shareRoomGooglePlusUrl(props.data.room)}
                      target="_blank"
                    >
                      <i className="fa fa-google-plus-square" />
                      google＋
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </li>
  </ul>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailSideBoxSp/index.jsx